import React from 'react';
import BaseInputWidget from './BaseInputWidget';

const SearchWidget = props => {
    return <BaseInputWidget type="search" {...props} />;
};

export default SearchWidget;
